export default {
    product: `Product`,
    products: `Products`,
    registerProduct: `Register Product`,
    mainInformation: 'Main Information',
    searchCustomerDetailsAndLocations: 'Search Customer Details & Locations',
    searchCustomerByMarking: 'Search Customer By Marking',
    entry: 'Entry',
    barcode: 'Barcode',
    modifyItemsForEntry: 'Modify items for Entry',
    updateProduct: 'Update Product',
    item: 'Item',
    addProductItem: 'Add Item',
    updateProductItem: 'Update Item',

    information: 'Information',
    detailInformationDescribedTheProducts: 'Detail information described the products',
    containerInfo: 'Container Info',
    detailInformationAssignedToContainer: 'Detail information assigned to container',
    detailInformationDescribedTheItems: 'Detail information described the items',
    updateProductInformation: 'Update product information',
    updateItemInformation: 'Update item information',
    updateProductImages: 'Update Product Images',
    removeItem: 'Remove Item',
    areYouSureToDeleteThisItem: 'Are you sure to delete this item?',
    yesIveConfirmed: `${"Yes I've Confirmed"}`,
    savedImages: 'Saved Images',
    describedTheImageInformation: 'Described the image information',
    noImagesSaved: 'No Images Saved.',
    dropImagesHereOrClickToSelectFilesForUpload: 'Drop images here, or click to select files for Upload',
    clearAll: 'Clear All',
    confirmUpload: 'Confirm Upload',
    galleryImage: 'Gallery Images',

    mainlandIdentityCard: 'Mainland Identity Card',
    currentImage: 'Current Image',
    previewImage: 'Preview Image',

    itemCode: 'Item Code',
    scanningSuffix: 'Scanning Suffix',
    prepayDepositFee: 'Prepay Deposit Fee',
    prepayTransportFee: 'Prepay Transport Fee',
    companyPurchaseNo: 'Company Purchase No.',
    handleUnit: 'Handle Unit',
    dimension: 'Dimension (LxWxH)',
    total: 'Total',

    assignedDO: 'Assigned DO',
    lastSaved: `Last Saved`,
    signedByUser: `Signed By`,
    searchBarcode: 'Search Barcode',

    unsaved: `Unsaved`,
    reset: `Reset`,
    checkedInAt: `Checked In`,
    hideMarking: 'Hide Marking',
    openMarking: 'Open Marking',

    changeOwner: `Change Owner`,
    latestResultFor: `Latest Results For`,
    searchMarking: `Search Marking`,
    searchRelatedProductsByTheMarking: `Search related products by marking`,
    applyTo: `Apply To`,
    confirmChangeOwnerToThisMarking: `Confirm Change Ownership To This Marking`,
    markingCannotEmpty: `Marking Cannot Empty`,
    markingCannotBeSame: `Marking Cannot be Same`,
    invalidMarkingInUpstream: `Invalid Marking In Upstream`,
    markingIsTrashInUpstream: `Marking Is Trashed In Upstream`,
    markingIsDeletedInUpstream: `Marking Is Deleted In Upstream`,
    markingIsDisabledInUpstream: `Marking Is Disabled In Upstream`,
    invalidMarking: `Invalid Marking`,
    moreThanOneMarkingExists: `More than one marking Existed`,
    upSteamSourceMarkingRemIdNotMatched: `Upstream source marking remid is not matched`,

    failedToDeleteTheFirstRowOfSavedItems: "Failed To Delete The First Row of Saved Items",
    deleteFirstRowOfSavedItems: "Delete First Row of Saved Items",

    printPackQty: 'Print Pack Qty',
    appEntry: 'App Entry',
    byApp: 'Yes',
    notFromApp: 'None',
    insertRows: 'Insert Rows',
    calculate: 'Calculate',
    tableGridV1: "Grid Table V1",
    tableGridV2: "Grid Table V2",

    maxOnly: 'Max Only',
    successfullyAdded: 'Successfully added',
    deleted: 'Deleted',
    success: 'Success',
    failed: 'Failed',
    minAtLeast1Item: 'Min at least 1 item',
    someOfItemsHasNotSyncFinished: 'Some of items has not sync finished [sourceRemId are empty]',
    minSelectOneItem: 'Min select (1) item',
    failedToUpdate: 'Failed to update',

    printLabels: "Print Labels",
    cancel: 'Cancel',
    printNo: 'Print No',

    unit: 'UNIT',
    box: 'BOX',
    sack: 'SACK',
    pallet: 'PALLET',
    wooden: 'WOODEN',
    woodenCrate: 'WD CRATE',
    long: 'LONG',

    filterAll: "Filter All",
    filterSimilar: "Filter Similar",

    // ------MUI------
    productName: 'Product Name',
    signedBy: 'Signed By',
    addItems: 'Add Items',

    gender: 'Gender',
    nation: 'Nation',
    dateOfBirth: 'Date of Birth',
    identityNo: 'Identity No.',
    department: 'Department',
    validityTime: 'Validity Time',

    payFreight: 'Pay Freight',
    payDeposit: 'Pay Deposit',
}